<h2>Financial Model</h2>

<digires-file-card title="Financial Model File"
                   [fileId]="fileId"
                   [deletable]="true"
                   [isAllowedToDelete]="canEdit && canDelete && !!fileId"
                   [isAllowedToUpload]="canEdit"
                   [acceptedFileTypes]="EXCEL_ONLY"
                   (upload)="onUpload($event)"
                   (delete)="fileDelete.emit()"
></digires-file-card>

<section id="meta-info">
  <digires-text-input [formGroup]="financialModelDataFg"
                      [initialData]="financialModelInitialData"
                      [readOnly]="true"
                      readOnlyReason="Read from Financial Model"
                      formCtrlName="preferredScenarioTitle"
                      placeholder="Preferred Scenario Title"
  ></digires-text-input>
  <digires-text-input [formGroup]="financialModelDataFg"
                      [initialData]="financialModelInitialData"
                      [readOnly]="true"
                      readOnlyReason="Read from Financial Model"
                      formCtrlName="type"
                      placeholder="Financial Model Type"
  ></digires-text-input>
  <digires-text-input [formGroup]="financialModelDataFg"
                      [initialData]="financialModelInitialData"
                      [readOnly]="true"
                      readOnlyReason="Read from Financial Model"
                      formCtrlName="preferredScenarioNumber"
                      placeholder="Preferred Scenario Number"
  ></digires-text-input>
  <digires-text-input [formGroup]="financialModelDataFg"
                      [initialData]="financialModelInitialData"
                      [readOnly]="true"
                      readOnlyReason="Read from Financial Model"
                      formCtrlName="version"
                      placeholder="Financial Model Version"
  ></digires-text-input>
</section>

<section *ngIf="financialModel?.errors?.length > 0" id="warnings">

  <div class="row">
    <p>
      Please Note: The list below shows the data fields in the financial model that couldn’t be read when it was
      uploaded, however this may be the desired outcome, for example where the project only contains Onshore Wind
      then it is expected that fields relating to Solar would not be updated.
    </p>
    <p>{{financialModel.errors.length}} data fields could not be updated from the financial model for the following reasons:</p>
    <button mat-button class="btnNeutral" (click)="onCopyErrors()">Copy Warnings to Clipboard</button>
  </div>

  <table>
    <tr>
      <th class="financial-model-warning-table-header">Financial Model Data Field</th>
      <th class="financial-model-warning-table-header">Data Validation Check</th>
    </tr>

    <tr *ngFor="let error of financialModel.errors">
      <td class="financial-model-warning-table-cell">{{error.propertyName}}</td>
      <td class="financial-model-warning-table-cell">
        {{error.errorMessage}}
        <mat-icon class="tooltip-icon" svgIcon="tooltip" matTooltipPosition="right"
                  matTooltip="{{financialModelErrorToTooltip[error.errorType]}}"
        ></mat-icon>
      </td>
    </tr>
  </table>

</section>
